module.exports = __webpack_public_path__ + "media/6_2.5fd204ac.mp3";